import { createSlice } from "@reduxjs/toolkit";
import { reducerRegistry } from "@/utils/redux";
import { initialState, reducers } from "./reducers";

const slice = createSlice({
  name: "MoodMonitoringContacts",
  initialState,
  reducers,
});

export const { actions, reducer } = slice;
export const { getMoodContacts, getMoodContactsError, getMoodContactsSuccess } =
  slice.actions;

reducerRegistry.register("moodMonitoringContacts", reducer);
